import amplitude from 'amplitude-js';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getFirebase } from 'react-redux-firebase';
import { push } from 'react-router-redux';

import AMPLITUDE_EVENT_NAMES from '../../amplitude/constants';
import { logAmplitudeEvent, setAmplitudeUserId } from '../actions/amplitude';
import {
  requestSignIn,
  requestSignInError,
  requestSignInSuccess,
  SIGN_IN_INITIATED,
} from '../actions/signIn';
import {
  requestSignUp,
  requestSignUpError,
  requestSignUpSuccess,
  SIGN_UP_INITIATED,
} from '../actions/signUp';
import { SIGN_OUT } from '../actions/signOut';

const signUp = function* signUp({ email, password, organization }) {
  yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_UP_SUBMIT));
  try {
    yield put(requestSignUp());
    const res = yield getFirebase().createUser({ email, password }, { email, organization });
    yield put(requestSignUpSuccess());
    yield call(setUserIdIfAuthenticated, res);
    yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_UP_SUCCESS));
    yield put(push('/sign-up-success'));
  } catch(err) {
    console.log(err);
    yield put(requestSignUpError());
    yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_UP_FAILURE));
  }
};

const watchSignUp = function* watchSignUp() {
  yield takeLatest(SIGN_UP_INITIATED, signUp);
};

const signIn = function* signIn({ email, password }) {
  yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_IN_SUBMIT));
  try {
    yield put(requestSignIn());
    const res = yield getFirebase().login({ email, password });
    yield put(requestSignInSuccess());
    yield call(setUserIdIfAuthenticated, res.user.user);
    yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_IN_SUCCESS));
    yield put(push('/'));
  } catch(err) {
    yield put(requestSignInError());
    yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_IN_FAILURE));
  }
};

const watchSignIn = function* watchSignIn() {
  yield takeLatest(SIGN_IN_INITIATED, signIn);
};

const setUserIdIfAuthenticated = function* setUserIdIfAuthenticated(user) {
  if (user.email) {
    yield put(setAmplitudeUserId(user.email));
  }
};

const signOut = function* signOut() {
  try {
    yield getFirebase().logout();
    yield put(push('/'));
  } catch(err) {
    yield call(amplitude.getInstance().setUserId, null);
  }
};

const watchSignOut = function* watchSignOut() {
  yield takeLatest(SIGN_OUT, signOut);
};

export {
  watchSignIn,
  watchSignOut,
  watchSignUp,
}



// WEBPACK FOOTER //
// ./src/redux/sagas/auth.js